import React from "react";
import { ArrowDown } from "lucide-react";
import { useLang } from "../context/LangContext";

const HERO_IMG = "https://images.unsplash.com/photo-1754475205146-23ca0cd6e73f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxtdXNjdWxhciUyMG1hbGUlMjBtb2RlbCUyMHN0dWRpbyUyMGRhcmt8ZW58MHx8fHwxNzgwOTI0MDEyfDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const { t } = useLang();
  const scroll = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" data-testid="hero-section" className="relative h-screen min-h-[720px] w-full overflow-hidden">
      <img
        src={HERO_IMG}
        alt="Intimo Models hero"
        className="absolute inset-0 w-full h-full object-cover object-center grayscale-[20%] scale-105"
        loading="eager"
      />
      <div className="absolute inset-0 hero-overlay" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/95 via-[#050505]/40 to-transparent" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-end pb-24 lg:pb-32">
        <div className="max-w-3xl fade-up">
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-12 h-px bg-[#00E5FF]" />
            <span className="label-eyebrow text-[#00E5FF]">{t.hero.eyebrow}</span>
          </div>

          <h1 data-testid="hero-title" className="font-display uppercase text-white leading-[0.95] tracking-tighter">
            <span className="block text-5xl sm:text-6xl lg:text-7xl text-neutral-400 font-extralight">{t.hero.titleA}</span>
            <span className="block text-6xl sm:text-7xl lg:text-8xl">{t.hero.titleB}</span>
            <span className="block text-7xl sm:text-8xl lg:text-9xl text-[#00E5FF] glow-text">{t.hero.titleC}</span>
          </h1>

          <p className="mt-8 text-base sm:text-lg text-neutral-300 max-w-xl font-light leading-relaxed">
            {t.hero.tagline}
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <button data-testid="hero-cta-apply" onClick={() => scroll("apply")} className="btn-solid">
              {t.hero.cta} →
            </button>
            <button data-testid="hero-cta-requirements" onClick={() => scroll("requirements")} className="btn-ghost">
              {t.hero.ctaSecondary}
            </button>
          </div>
        </div>

        <div className="absolute bottom-8 right-8 hidden lg:flex items-center gap-3 text-neutral-500">
          <span className="label-eyebrow">Scroll</span>
          <ArrowDown size={14} className="text-[#00E5FF] animate-bounce" />
        </div>
      </div>
    </section>
  );
}
